import { render, staticRenderFns } from "./PaymentPlanWrapper.vue?vue&type=template&id=be874932&scoped=true"
import script from "./PaymentPlanWrapper.vue?vue&type=script&lang=js"
export * from "./PaymentPlanWrapper.vue?vue&type=script&lang=js"
import style0 from "./PaymentPlanWrapper.vue?vue&type=style&index=0&id=be874932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be874932",
  null
  
)

export default component.exports